(ns common.advertiser.hooks
  (:require [common.queries :refer [use-query]]
            [common.resource.query.advertiser :as q]
            [uix.core :refer [defhook] :as uix]
            [uix.re-frame :refer [use-subscribe]]))

(defhook use-demo-advertiser []
  (let [{:keys [advertiser-id]} (use-subscribe [:url-context])
        {{:keys [isDemo]} :data} (use-query (q/advertiser-query {:advertiser-id advertiser-id}))]
    {:is-demo isDemo}))